import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import ur from "../locales/ur.json";

const language = localStorage.getItem("language") || "en";

function applyLanguage(nextLanguage: string): void {
  document.documentElement.lang = nextLanguage;
  document.documentElement.dir = nextLanguage === "ur" ? "rtl" : "ltr";
  localStorage.setItem("language", nextLanguage);
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ur: { translation: ur } },
  lng: language,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

applyLanguage(language);
i18n.on("languageChanged", applyLanguage);

export default i18n;
